/* ================================================================ */
/*  MM JUDGE.ME — Custom JS enhancements                            */
/*  1. Reformat review dates (24/02/2026 → 12 juin 2025)           */
/*  2. Add rating label next to stars (ex: "4/5")                   */
/*  3. Move sort dropdown above reviews list (right column)         */
/* ================================================================ */

(function () {
  const MONTHS = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ];

  /**
   * 1. Reformat dates from DD/MM/YYYY to "DD mois YYYY"
   */
  function reformatDates() {
    const dateElements = document.querySelectorAll('.jm-reviewer-info__details .jm-text');

    dateElements.forEach(function (el) {
      const text = el.textContent.trim();
      const match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

      if (match) {
        const day = parseInt(match[1], 10);
        const monthIndex = parseInt(match[2], 10) - 1;
        const year = match[3];

        if (monthIndex >= 0 && monthIndex < 12) {
          el.textContent = day + ' ' + MONTHS[monthIndex] + ' ' + year;
        }
      }
    });
  }

  /**
   * 2. Add "X/5" label next to review stars
   */
  function addRatingLabels() {
    const starRatings = document.querySelectorAll('.jm-review-item .jm-star-rating');

    starRatings.forEach(function (el) {
      // Skip if already processed
      if (el.querySelector('.mm-rating-label')) return;

      var ariaLabel = el.getAttribute('aria-label') || '';
      var match = ariaLabel.match(/(\d+)\s*out\s*of\s*(\d+)/);

      if (match) {
        var label = document.createElement('span');
        label.className = 'mm-rating-label';
        label.textContent = match[1] + '/' + match[2];
        el.appendChild(label);
      }
    });
  }

  /**
   * 3. Move sort dropdown & replace with custom select
   */
  var sortMoved = false;
  function moveSortDropdown() {
    if (sortMoved) return;

    var sortFilter = document.querySelector('.jm-sort-filter');
    var reviewBody = document.querySelector('.jm-review-widget__body');
    var nativeSelect = sortFilter ? sortFilter.querySelector('select') : null;

    if (!sortFilter || !reviewBody || !nativeSelect) return;

    // Hide native sort filter
    sortFilter.style.display = 'none';

    // Build custom dropdown
    var wrapper = document.createElement('div');
    wrapper.className = 'mm-sort-wrapper';

    var custom = document.createElement('div');
    custom.className = 'mm-custom-select';

    // Selected display
    var selected = document.createElement('button');
    selected.className = 'mm-custom-select__trigger';
    selected.type = 'button';

    var labelSpan = document.createElement('span');
    labelSpan.className = 'mm-custom-select__label';
    labelSpan.textContent = 'Trier par';

    var valueSpan = document.createElement('span');
    valueSpan.className = 'mm-custom-select__value';
    valueSpan.textContent = nativeSelect.options[nativeSelect.selectedIndex].text;

    selected.appendChild(labelSpan);
    selected.appendChild(valueSpan);

    // Dropdown panel
    var panel = document.createElement('div');
    panel.className = 'mm-custom-select__panel';

    for (var i = 0; i < nativeSelect.options.length; i++) {
      var opt = nativeSelect.options[i];
      var item = document.createElement('button');
      item.className = 'mm-custom-select__option';
      item.type = 'button';
      item.textContent = opt.text;
      item.setAttribute('data-value', opt.value);
      if (i === nativeSelect.selectedIndex) {
        item.classList.add('is-active');
      }
      item.addEventListener('click', (function (value, text) {
        return function () {
          // Update native select to trigger JudgeMe sort
          nativeSelect.value = value;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          // Update UI
          valueSpan.textContent = text;
          panel.querySelectorAll('.mm-custom-select__option').forEach(function (o) {
            o.classList.remove('is-active');
          });
          this.classList.add('is-active');
          custom.classList.remove('is-open');
        };
      })(opt.value, opt.text));
      panel.appendChild(item);
    }

    // Toggle
    selected.addEventListener('click', function () {
      custom.classList.toggle('is-open');
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!custom.contains(e.target)) {
        custom.classList.remove('is-open');
      }
    });

    custom.appendChild(selected);
    custom.appendChild(panel);
    wrapper.appendChild(custom);
    reviewBody.insertBefore(wrapper, reviewBody.firstChild);
    sortMoved = true;
  }

  /**
   * 4. Review modal — scroll lock + close on overlay click
   */
  function setupModal() {
    var lastModalState = false;

    function checkModal() {
      var modal = document.querySelector('.jdgm-review-widget-modal');
      if (!modal) return;

      var isVisible = modal.style.display === 'block';

      if (isVisible !== lastModalState) {
        lastModalState = isVisible;
        document.body.style.overflow = isVisible ? 'hidden' : '';
      }
    }

    setInterval(checkModal, 200);

    // Close on click outside modal content (use mousedown for reliability)
    document.addEventListener('mousedown', function (e) {
      var modal = document.querySelector('.jdgm-review-widget-modal');
      if (!modal || modal.style.display !== 'block') return;

      // Find the actual modal content box
      var content = modal.querySelector('.jdgm-write-review-modal__content') ||
                    modal.querySelector('.jdgm-write-review-modal__container');
      if (!content) return;

      // If click is outside the content box, close
      var rect = content.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right ||
          e.clientY < rect.top || e.clientY > rect.bottom) {
        var closeBtn = modal.querySelector('.jdgm-write-review-modal__close-btn');
        if (closeBtn) {
          e.preventDefault();
          closeBtn.click();
        }
      }
    });
  }

  /**
   * 5. Move pagination to end of reviews body
   */
  function movePagination() {
    var pagination = document.querySelector('.jm-pagination-controls');
    var reviewBody = document.querySelector('.jm-review-widget__body');

    if (pagination && reviewBody && pagination.parentNode !== reviewBody) {
      reviewBody.appendChild(pagination);
    }
  }

  /**
   * Run all enhancements — with MutationObserver for dynamic content
   */
  function runAll() {
    moveSortDropdown();
    reformatDates();
    addRatingLabels();
    movePagination();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runAll();
      setupModal();
    });
  } else {
    runAll();
    setupModal();
  }

  // Watch for JudgeMe dynamic content (pagination, lazy load)
  var observer = new MutationObserver(function (mutations) {
    var hasNewReviews = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (hasNewReviews) runAll();
  });

  var target = document.getElementById('judgeme_product_reviews');
  if (target) {
    observer.observe(target, { childList: true, subtree: true });
  } else {
    // Widget not yet in DOM — wait for it
    document.addEventListener('DOMContentLoaded', function () {
      var t = document.getElementById('judgeme_product_reviews');
      if (t) observer.observe(t, { childList: true, subtree: true });
    });
  }
})();
